import * as React from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/auth/AuthContext";
import { auth } from "../firebase";
import { useAppDispatch } from "./useRedux";
import { handleClearPractice } from "../redux/features/practice/practiceSlice";
import { setUnauthorizedLogoutHandler } from "../utils/axios";
import { clearPracticeSession } from "../utils/practiceSessionStore";

export default function useAuthContext() {
    const user = React.useContext(AuthContext);

    const dispatch = useAppDispatch();

    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const isLoggingOutRef = React.useRef(false);

    const logOutUser = React.useCallback(async () => {
        if (isLoggingOutRef.current) {
            return;
        }

        isLoggingOutRef.current = true;

        try {
            await queryClient.cancelQueries({ queryKey: ["user-details"] });
            await auth.signOut();
        } finally {
            clearPracticeSession();
            localStorage.removeItem("from");
            dispatch(handleClearPractice());
            queryClient.clear();
            navigate("/login", { replace: true });
            isLoggingOutRef.current = false;
        }
    }, [dispatch, navigate, queryClient]);

    React.useEffect(() => {
        setUnauthorizedLogoutHandler(logOutUser);

        return () => {
            setUnauthorizedLogoutHandler(null);
        };
    }, [logOutUser]);

    return { user, logOutUser };
}
